import { DEFAULT_PAGE_SIZE } from '@/_hooks/useUrlPagination';

export const initialDataCount = 99000;

export interface UserFilterModel {
  index?: number;
  size?: number;
  search?: string;
  status?: number | null;
  roles?: string[];
  parentId?: string | null;
  companyIds?: string[];
  channelIds?: string[];
}

export const initialFilterParams_User: UserFilterModel = {
  search: '',
  status: null,
  roles: [],
  companyIds: [],
  channelIds: [],
  parentId: null,
  size: DEFAULT_PAGE_SIZE,
  index: 0,
};
